import Vue from 'vue'
import Router from 'vue-router'
import Consent from '@/components/Pages/Consent'
import Settings from '@/components/Pages/Settings'
import ExperimentAgree from '@/components/Pages/ExperimentAgree'
import RouteSearch from '@/components/Pages/RouteSearch'
import DropSpotSelect from '@/components/Pages/DropSpotSelect'
import RouteResult from '@/components/Pages/RouteResult'
import Answers from '@/components/Pages/Answers'
import NotFound from '@/components/Pages/NotFound'

Vue.use(Router)
Vue.use(require('vue-cookies'))

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Consent',
      component: Consent
    },
    {
      path: '/setting',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/experiment',
      name: 'ExperimentAgree',
      component: ExperimentAgree
    },
    {
      path: '/search',
      name: 'RouteSearch',
      component: RouteSearch
    },
    {
      path: '/dropspot',
      name: 'DropSpotSelect',
      component: DropSpotSelect
    },
    {
      path: '/result',
      name: 'RouteResult',
      component: RouteResult
    },
    {
      path: '/answers',
      name: 'Answers',
      component: Answers
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js